import { Component, inject, OnInit } from '@angular/core';

import { ButtonModule, DialogRef, IconModule, WINDOW } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '@fb/environments';

import { AiChatFormDialog } from '../ai-chat-form/ai-chat-form.dialog';
import { SupportFormDialog } from '../support-form/support-form.dialog';
import { TranslateInPipe } from '../../pipes/translate-in.pipe';
import { SupportCategories } from '../../models';

@Component({
  selector: 'pu-finance-dialog',
  templateUrl: './finance-dialog.component.html',
  styleUrl: './finance-dialog.component.scss',
  imports: [ButtonModule, IconModule, TranslateModule, TranslateInPipe],
  providers: [AiChatFormDialog, SupportFormDialog],
})
export class FinanceDialogComponent implements OnInit {
  #dialogRef = inject(DialogRef);
  #aiChatFormDialog = inject(AiChatFormDialog);
  #supportFormDialog = inject(SupportFormDialog);
  #window = inject(WINDOW);

  categories = SupportCategories;

  assetsUrl = environment.assetsUrl;
  financeConfluenceLink = environment.financeConfluenceLink;
  aiChatButtonIcon = `${environment.shortName}-ai-chat-button`;

  ngOnInit(): void {
    const officeLocation = this.#window.localStorage.getItem('office_location_original');
    const locationMapper = new Map<string, string>()
      .set('AM COM', 'https://wiki.time2go.tech/display/WORLD/AM+COM')
      .set('CY HQ', 'https://wiki.time2go.tech/display/WORLD/CY+HQ')
      .set('KZ Global', 'https://wiki.time2go.tech/display/WORLD/KZ+Global')
      .set('KZ License', 'https://wiki.time2go.tech/display/WORLD/KZ+License')
      .set('PL COM', 'https://wiki.time2go.tech/display/WORLD/PL+COM')
      .set('PL CS', 'https://wiki.time2go.tech/display/WORLD/PL+COM')
      .set('UA IT', 'https://wiki.time2go.tech/display/WORLD/UA+COM')
      .set('UA License', 'https://wiki.time2go.tech/display/WORLD/UA+COM');

    this.financeConfluenceLink = locationMapper.get(officeLocation) || environment.financeConfluenceLink;
  }

  openSupport() {
    this.close();
    this.#supportFormDialog.open(this.categories.finance);
  }

  openChat() {
    this.close();
    this.#aiChatFormDialog.open();
  }

  close(): void {
    this.#dialogRef.close();
  }
}
